import apiClient from "../Util/ApiClient";

export default class TransactionApi {
    static cancelTransaction = (accountCode: string, code:string) => {
        return apiClient.patch(`accounts/${accountCode}/transactions/${code}/status`, {
            status: "REJECTED"
        })
    }
}
